// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"room__styles__tooltip___3Nhxmu","slideIn":"room__styles__slideIn___3HTtUN","triggerWrapper":"room__styles__triggerWrapper___3TvJzw"};